import { useMemo } from 'react';
import { Country } from '@tiendanube/common/src/enums';
import { useGetCountry } from 'domains/Auth/hooks';
import { PopoverUnpacked } from 'domains/NuvemEnvioCommons/components';
import { DefaultSavedSearchesCode } from '../defaultSavedSearches';
import { PickupEmailPopover } from '../Popovers';
import { SavedSearchInterface } from '../types';

interface SavedSearchPopoverWrapperProps {
  isSelected: boolean;
  savedSearch: SavedSearchInterface;
  children: React.ReactNode;
}

export function SavedSearchPopoverWrapper({
  children,
  isSelected,
  savedSearch,
}: SavedSearchPopoverWrapperProps) {
  const country = useGetCountry();

  const showPopover = useMemo(() => {
    const showUnpackedOrSendPopover =
      country === Country.BR &&
      isSelected &&
      (savedSearch.code === DefaultSavedSearchesCode.READY_TO_PACK ||
        savedSearch.code === DefaultSavedSearchesCode.READY_TO_SEND);

    const showReadyToPickupPopover =
      isSelected &&
      savedSearch.code === DefaultSavedSearchesCode.READY_TO_PICKUP;

    switch (savedSearch.code) {
      case DefaultSavedSearchesCode.READY_TO_PACK:
        return showUnpackedOrSendPopover;
      case DefaultSavedSearchesCode.READY_TO_SEND:
        return showUnpackedOrSendPopover;
      case DefaultSavedSearchesCode.READY_TO_PICKUP:
        return showReadyToPickupPopover;
      default:
        return false;
    }
  }, [isSelected, country, savedSearch.code]);

  const Popover = useMemo(() => {
    switch (savedSearch.code) {
      case DefaultSavedSearchesCode.READY_TO_PACK:
      case DefaultSavedSearchesCode.READY_TO_SEND:
        return PopoverUnpacked;
      case DefaultSavedSearchesCode.READY_TO_PICKUP:
        return PickupEmailPopover;
      default:
        return undefined;
    }
  }, [savedSearch.code]);

  // While not selected we avoid rendering the popover
  // to prevent unnecessary data fetching from the popover component logic
  if (!Popover || !showPopover) {
    return <div>{children}</div>;
  }

  return <Popover isSelected={showPopover}>{children}</Popover>;
}
